import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetPaginatedPending(requestedPage) {
  const common = page => ({
    url: '/api/v1/profiles/me/wires/pending',
    params: { page },
  });
  const [state, q] = useAxios({
    method: 'GET',
    ...common(requestedPage),
  }, { manual: true });
  const executeQuery = page => q(common(page));
  return [state, executeQuery];
}
